import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { ThemeProvider, breakpoints } from 'styled'

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={{ breakpoints }}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
)
